import { render } from "./PeopleSearchForm.vue?vue&type=template&id=fe1deaa0&scoped=true"
import script from "./PeopleSearchForm.vue?vue&type=script&lang=js"
export * from "./PeopleSearchForm.vue?vue&type=script&lang=js"

import "./PeopleSearchForm.vue?vue&type=style&index=0&id=fe1deaa0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fe1deaa0"

export default script